// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain as LoadProductInfoListChain,
    LoadRealTimeInventory,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { xGoogleAnalyticsState } from "@sc/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@sc/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { parseProductCategories } from "@sc/XDL/Utilities";

const _GaTrackViewItemList: typeof LoadRealTimeInventory = props => {
    setTimeout(() => {
        const dataLayer = getDataLayer();
        const state = props.getState() as xGoogleAnalyticsState;
        const productInfos = state.components.productInfoLists.productInfoListById[props.parameter.id];
        const currencyCode = state.context?.session?.currency?.currencyCode;
        const locationId = state.context?.session.pickUpWarehouse?.id;

        if (
            dataLayer &&
            state.xGoogleAnalytics?.productImpressionEvent &&
            productInfos?.productInfoByProductId &&
            props.products?.length
        ) {
            const isDuplicateEvent = dataLayer.find(
                (d: any) =>
                    d.event === state.xGoogleAnalytics?.productImpressionEventName &&
                    d.ecommerce.item_list_id === props.parameter.id,
            );

            const widgetData = getWidgetsByPageId(state, getCurrentPage(state).id).find(
                widget => widget.id === props.parameter.id,
            );

            if (!isDuplicateEvent) {
                const googleAnalyticsData = {
                    event: state.xGoogleAnalytics?.productImpressionEventName,
                    ecommerce: {
                        item_list_id: props.parameter.id,
                        item_list_name:
                            Object.values(widgetData?.contextualFields.title || {})[0] ||
                            widgetData?.type ||
                            "Product Carousel",
                        currency: currencyCode,
                        affiliation: state.xGoogleAnalytics.affiliation || "",
                        sales_rep: state.xGoogleAnalytics.salesRep || "",
                        is_rep: state.xGoogleAnalytics.isRep || "",
                        bill_to_num: state.xGoogleAnalytics.billToNum || "",
                        ship_to_num: state.xGoogleAnalytics.shipToNum || "",
                        cust_type: state.xGoogleAnalytics.customerType || "",
                        login_type: state.xGoogleAnalytics.loginType || "",
                        warehouse: state.xGoogleAnalytics.warehouse || "",
                        items: [] as any,
                        url: window.location.href,
                    },
                };

                props.products?.forEach((product, idx) => {
                    const productInfo = productInfos.productInfoByProductId[product.id];

                    googleAnalyticsData.ecommerce.items.push({
                        item_name: product?.productTitle,
                        item_id: product?.productNumber,
                        affiliation: state.xGoogleAnalytics.affiliation || "",
                        price: productInfo?.pricing?.unitNetPrice || "",
                        index: idx,
                        item_brand: state.xGoogleAnalytics["includeProductBrand"]
                            ? product?.brand?.name || ""
                            : undefined,
                        item_list_id: state.xGoogleAnalytics["includeProductCategory"]
                            ? product?.properties?.["categoryId"] || ""
                            : undefined,
                        item_list_name:
                            Object.values(widgetData?.contextualFields.title || {})[0] ||
                            widgetData?.type ||
                            "Product Carousel",
                        items_available: productInfo?.inventory?.qtyOnHand || 0,
                        item_variant: "",
                        location_id: locationId,
                        coupon: "",
                        ...parseProductCategories(
                            product?.properties?.itemCategoriesShortDescription,
                            true,
                            state.xGoogleAnalytics["includeProductCategory"],
                        ),
                    });
                });

                dataLayer.push({ ecommerce: null });
                dataLayer.push(googleAnalyticsData);
            }
        }
    }, 1000);
};

addToEndOfChain(LoadProductInfoListChain, _GaTrackViewItemList);
